import Types from './type';

export const getPropByPath = (obj, path, strict) => {
    let tempObj = obj;
    path = path.replace(/\[(\w+)\]/g, '.$1');
    path = path.replace(/^\./, '');

    const keyArr = path.split('.');
    let i = 0;
    for (let len = keyArr.length; i < len - 1; ++i) {
        if (!tempObj && !strict) break;
        const key = keyArr[i];
        if (key in tempObj) {
            tempObj = tempObj[key];
        } else {
            if (strict) {
                throw new Error('please transfer a valid prop path to form item!');
            }
            break;
        }
    }
    return {
        o: tempObj,
        k: keyArr[i],
        v: tempObj ? tempObj[keyArr[i]] : null
    };
};
// 数组判等
export const isEqArray = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, index) => {
        if (item === arr2[index]) return true;
        if (Types.object(item) && Types.object(arr2[index])) {
            return isEqObject(item, arr2[index]);
        }
        if (Types.array(item) && Types.array(arr2[index])) {
            return isEqArray(item, arr2[index]);
        }
        return false;
    });
};
// 对象判等
export const isEqObject = (obj1, obj2) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    return keys1.every(item => {
        if (obj1[item] === obj2[item]) return true;
        if (Types.object(obj1[item]) && Types.object(obj2[item])) {
            return isEqObject(obj1[item], obj2[item]);
        }
        if (Types.array(obj1[item]) && Types.array(obj2[item])) {
            return isEqArray(obj1[item], obj2[item]);
        }
        return false;
    });
};

export const getTargetValue = (target, data) => {
    let res = [];
    if (Types.array(target)) {
        if (target.length) {
            target.forEach(item => {
                const v = getPropByPath(data, item);
                res.push(v);
            });
        }
    } else {
        res = getPropByPath(data, target);
    }
    return res;
};

export const compareNumber = (value, base, flag) => {
    if (flag === 'lt' && +value >= +base) return false;
    if (flag === 'le' && +value > +base) return false;
    if (flag === 'eq' && +value !== +base) return false;
    if (flag === 'ne' && +value === +base) return false;
    if (flag === 'ge' && +value < +base) return false;
    if (flag === 'gt' && +value <= +base) return false;
    return true;
};
